import { createSelector } from "reselect";

import { getRouteParam } from "./route";

export const getChannelsById = (state) => state.channel.byId;

const getChannelList = (state) =>
  Object.keys(state.channel.byId).map((id) => state.channel.byId[id]);

export const getActiveChannels = createSelector([getChannelList], (channels) =>
  channels.filter((c) => c.status && c.status.active)
);

export const getForecastChannels = createSelector(
  [getChannelList],
  (channels) =>
    channels.filter((channel) => channel.status && channel.status.forecast)
);

export const getThisChannel = createSelector(
  [getChannelsById, getRouteParam("id")],
  (channels, id) => channels[id]
);
